import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const AccountingRoleIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3 9H21"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.36475 16.6401H8.27783L7.82861 15.2241L7.36475 16.6401ZM7.41113 14.4014H8.26074L9.53516 18H8.71973L8.48779 17.2602H7.16211L6.91309 18H6.12695L7.41113 14.4014Z"
                fill={props.htmlColor || '#21272E'}
            />
            <path
                d="M9.83789 16.23C9.83789 15.6017 10.0063 15.1175 10.3433 14.7773C10.6362 14.4811 11.009 14.333 11.4614 14.333C12.0669 14.333 12.5096 14.5316 12.7896 14.9287C12.9442 15.1517 13.0272 15.3755 13.0386 15.6001H12.2866C12.2378 15.4276 12.1751 15.2973 12.0986 15.2095C11.9619 15.0532 11.7593 14.9751 11.4907 14.9751C11.2173 14.9751 11.0016 15.0858 10.8438 15.3071C10.6859 15.5268 10.6069 15.8385 10.6069 16.2422C10.6069 16.6458 10.6899 16.9486 10.856 17.1504C11.0236 17.3506 11.236 17.4507 11.4932 17.4507C11.7568 17.4507 11.9578 17.3644 12.0962 17.1919C12.1727 17.0991 12.2362 16.9599 12.2866 16.7744H13.0313C12.9661 17.1667 12.7993 17.4857 12.5308 17.7314C12.2638 17.9772 11.9212 18.1001 11.5029 18.1001C10.9854 18.1001 10.5785 17.9341 10.2822 17.602C9.986 17.2684 9.83789 16.811 9.83789 16.23Z"
                fill={props.htmlColor || '#21272E'}
            />
            <path
                d="M13.4512 16.23C13.4512 15.6017 13.6196 15.1175 13.9565 14.7773C14.2495 14.4811 14.6222 14.333 15.0747 14.333C15.6802 14.333 16.1229 14.5316 16.4028 14.9287C16.5575 15.1517 16.6405 15.3755 16.6519 15.6001H15.8999C15.8511 15.4276 15.7884 15.2973 15.7119 15.2095C15.5752 15.0532 15.3726 14.9751 15.104 14.9751C14.8306 14.9751 14.6149 15.0858 14.457 15.3071C14.2992 15.5268 14.2202 15.8385 14.2202 16.2422C14.2202 16.6458 14.3032 16.9486 14.4692 17.1504C14.6369 17.3506 14.8493 17.4507 15.1064 17.4507C15.3701 17.4507 15.5711 17.3644 15.7095 17.1919C15.786 17.0991 15.8494 16.9599 15.8999 16.7744H16.6445C16.5794 17.1667 16.4126 17.4857 16.144 17.7314C15.8771 17.9772 15.5345 18.1001 15.1162 18.1001C14.5986 18.1001 14.1917 17.9341 13.8955 17.602C13.5993 17.2684 13.4512 16.811 13.4512 16.23Z"
                fill={props.htmlColor || '#21272E'}
            />
            <path d="M17.1523 17.2724H17.8921V18H17.1523V17.2724Z" fill={props.htmlColor || '#21272E'} />
        </SvgIcon>
    );
};
